import { z } from 'zod';

const GetLeadResponseMember = z.object({
  createdDatetime: z.string(),
  updatedDatetime: z.string().nullable(),
  leadMemberId: z.number(),
  journeyMemberId: z.string(),
  dateOfBirth: z.string().nullable(),
  gender: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  tobaccoUser: z.boolean().nullable(),
  relationship: z.enum(['SPOUSE', 'CHILD']).nullable(),
});

const GetLeadResponseAdditionalQuestion = z.object({
  createdDatetime: z.string(),
  updatedDatetime: z.string().nullable(),
  additionalQuestionId: z.number(),
  question: z.string(),
  answer: z.string(),
  journeyId: z.number(),
});

export const GetLeadResponse = z.object({
  content: z.array(
    z.object({
      leadId: z.number(),
      leadStatusId: z.number(),
      auctionLeadId: z.string().nullable(),
      userId: z.string(),
      sessionId: z.string(),
      domainUserId: z.string(),
      domainSessionId: z.string(),
      src: z.string(),
      productTypeId: z.number(),
      firstName: z.string(),
      lastName: z.string().nullable(),
      email: z.string().nullable(),
      areaCode: z.string().nullable(),
      phoneNumber: z.string().nullable(),
      gender: z.string().nullable(),
      maritalStatus: z.string().nullable(),
      householdSize: z.number(),
      householdIncome: z.number().nullable(),
      dateOfBirth: z.string().nullable(),
      address: z.string().nullable(),
      city: z.string().nullable(),
      state: z.string().nullable(),
      county: z.string().nullable(),
      countyFips: z.string().nullable(),
      zip: z.string().nullable(),
      trustedFormUrl: z.string().nullable(),
      landingUrl: z.string().nullable(),
      landingPage: z.string().nullable(),
      language: z.string().nullable(),
      traffic: z.string().nullable(),
      tcpaSession: z.string().nullable(),
      tcpaSite: z.string().nullable(),
      tcpaUniversalId: z.string().nullable(),
      tcpaUserAgent: z.string().nullable(),
      tcpaConsent: z.string().nullable(),
      tobaccoUser: z.boolean().nullable(),
      fpl: z.number().nullable(),
      transUnionIncome: z.number().nullable(),
      tier: z.string().nullable(),
      productFit: z.string().nullable(),
      consentDestinationId: z.number().nullable(),
      leadMembers: z.array(GetLeadResponseMember).optional(),
      additionalQuestions: z
        .array(GetLeadResponseAdditionalQuestion)
        .optional(),
    }),
  ),
});

// eslint-disable-next-line no-redeclare
export type GetLeadResponse = z.infer<typeof GetLeadResponse>;
